angular.module('gym.whats_new', []).config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.whats_new', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.whats_new.list', {
    url: '/whats_new',
    template: require('templates/gyms/whats_new/index.html.slim')
  }).state('gym.whats_new.show', {
    url: '/whats_new/:id',
    template: require('templates/gyms/whats_new/show.html.slim')
  });
}]);
